export const lightBg = () => ({ item: { backgroundColor: '#F4F6F9' } });
